import axios from 'axios';
import { Patient, Appointment, Intervention, CalendarEvent } from '../types';

// Detect current domain and use same for API
const getCurrentDomain = () => {
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return `${protocol}//${hostname}`;
  }
  return 'https://plannitas.com';
};

const API_BASE_URL = process.env.REACT_APP_API_URL || `${getCurrentDomain()}/api`;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Patients API
export const patientsApi = {
  getAll: (params?: { page?: number; limit?: number; search?: string } | Record<string, any>) =>
    api.get('/patients', { params }),
  
  getById: (id: string) =>
    api.get(`/patients/${id}`),
  
  create: (data: Partial<Patient>) =>
    api.post('/patients', data),
  
  update: (id: string, data: Partial<Patient>) =>
    api.put(`/patients/${id}`, data),
  
  delete: (id: string) =>
    api.delete(`/patients/${id}`),
  
  getHistory: (id: string) =>
    api.get(`/patients/${id}/history`),
};

// Appointments API
export const appointmentsApi = {
  // accept common query params (page/limit/search/status/start/end/patient)
  getAll: (params?: { page?: number; limit?: number; search?: string; status?: string; start?: string; end?: string; patient?: string } | Record<string, any>) =>
    api.get('/appointments', { params }),
  
  getCalendar: (start: string, end: string) =>
    api.get('/appointments/calendar', { params: { start, end } }),
  
  getById: (id: string) =>
    api.get(`/appointments/${id}`),
  
  create: (data: Partial<Appointment>) =>
    api.post('/appointments', data),
  
  update: (id: string, data: Partial<Appointment>) =>
    api.put(`/appointments/${id}`, data),
  
  delete: (id: string) =>
    api.delete(`/appointments/${id}`),
  
  updateStatus: (id: string, status: string) =>
    api.put(`/appointments/${id}/status`, { status }),
};

// Interventions API
export const interventionsApi = {
  getAll: (params?: { patient?: string; appointment?: string; type?: string; status?: string; limit?: number } | Record<string, any>) =>
    api.get('/interventions', { params }),
  
  getById: (id: string) =>
    api.get(`/interventions/${id}`),
  
  create: (data: Partial<Intervention>) =>
    api.post('/interventions', data),
  
  update: (id: string, data: Partial<Intervention>) =>
    api.put(`/interventions/${id}`, data),
  
  delete: (id: string) =>
    api.delete(`/interventions/${id}`),
  
  getByPatient: (patientId: string, params?: { type?: string; status?: string; limit?: number }) =>
    api.get(`/interventions/patient/${patientId}`, { params }),
  
  getStats: (params?: { startDate?: string; endDate?: string }) =>
    api.get('/interventions/stats/summary', { params }),
};

export default api;















